import { endOfMonth, startOfMonth } from 'date-fns';
import { previousMonth } from 'utils/date';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';

type FromDate = Date;
type ToDate = Date;
type IsLoad = boolean;

interface BillingFunnelTotal {
    actAmount: number;
    fixedStatisticAmount: number;
    fixedStatisticBonusAmount: number;
    fixedStatisticRealAmount: number;
    statisticAmount: number;
}

interface BillingFunnelData extends BillingFunnelTotal {
    accountId: number;
    realFixedStatisticAndActDiff: number;
    statisticAndFixedStatisticDiff: number;
}

// ----------------------- actions -------------------------------------
const SET_BILLING_FUNNEL_DATES = 'SET_BILLING_FUNNEL_DATES';
const SET_BILLING_FUNNEL_DATA = 'SET_BILLING_FUNNEL_DATA';
const SET_BILLING_FUNNEL_TOTAL = 'SET_BILLING_FUNNEL_TOTAL';
const SET_LOAD_BILLING_FUNNEL_DATA = 'SET_LOAD_BILLING_FUNNEL_DATA';

interface PayloadTypes {
    [SET_BILLING_FUNNEL_DATES]: { from: FromDate; to: ToDate };
    [SET_BILLING_FUNNEL_DATA]: BillingFunnelData[];
    [SET_BILLING_FUNNEL_TOTAL]: BillingFunnelTotal;
    [SET_LOAD_BILLING_FUNNEL_DATA]: IsLoad;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setBillingFunnelDates = ActionCreator(SET_BILLING_FUNNEL_DATES);
export const setBillingFunnelData = ActionCreator(SET_BILLING_FUNNEL_DATA);
export const setBillingFunnelTotal = ActionCreator(SET_BILLING_FUNNEL_TOTAL);
export const setLoadBillingFunnelData = ActionCreator(SET_LOAD_BILLING_FUNNEL_DATA);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface BillingFunnelState {
    from: FromDate;
    to: ToDate;
    billingFunnelData: BillingFunnelData[];
    billingFunnelTotal: BillingFunnelTotal;
    isLoad: boolean;
}

const BILLING_FUNNEL_INITIAL_STATE: BillingFunnelState = {
    from: startOfMonth(previousMonth),
    to: endOfMonth(previousMonth),
    billingFunnelData: [],
    billingFunnelTotal: {
        actAmount: 0,
        fixedStatisticAmount: 0,
        fixedStatisticBonusAmount: 0,
        fixedStatisticRealAmount: 0,
        statisticAmount: 0,
    },
    isLoad: false,
};

export default createReducer<BillingFunnelState, PayloadTypes>(BILLING_FUNNEL_INITIAL_STATE, {
    [SET_BILLING_FUNNEL_DATES]: (state, { payload }) => ({
        ...state,
        from: payload.from,
        to: payload.to,
    }),
    [SET_BILLING_FUNNEL_DATA]: (state, { payload }) => ({
        ...state,
        billingFunnelData: payload,
    }),
    [SET_BILLING_FUNNEL_TOTAL]: (state, { payload }) => ({
        ...state,
        billingFunnelTotal: payload,
    }),
    [SET_LOAD_BILLING_FUNNEL_DATA]: (state, { payload }) => ({
        ...state,
        isLoad: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
